import React, { Component } from 'react';
import Form from '../../components/Form/Form';
import axios from '../../axios-orders.js';
import { connect } from 'react-redux';
import { orderHandler, orderPurchased } from '../../store/actions/order';
import Spinner from '../../components/UI/spinner/spinnner';
import withErrorHandler from '../../hoc/withErrorHandler';
import updateState from '../../utility'


class ContactData extends Component {


    state = {

        customer: {
            name: '',

            street: '',
            zipcode: '',

            email: ''
        },
        price: this.props.totalPrice,
        deliveryMethod: '',

    }

    componentDidUpdate(){
        this.props.orderPurchased();
    }


    nameHandler = (e) => {
        let value = e.target.value;
        let prop = e.target.placeholder;
        let customer = { ...this.state.customer };

        customer[prop] = value;

        this.setState({ customer: customer });

    }

    submitHandler = (e) => {
        e.preventDefault();


        let order = { ...this.state };
        if (order.customer.customer !== '' && order.customer.address !== '' && order.customer.email !== '') {
            const customerDetails = updateState(order, {ingredients: this.props.ingredients,
                                                             userId: this.props.userId});
            this.props.orderHandler(customerDetails, this.props.token);
            if(this.props.purchased){
                this.props.history.replace('/');
            }
        } else
            alert('Please Fill out the form');

    }

    deliveryMethodHandler = (e) => {
        let value = e.target.value;
        this.setState({ deliveryMethod: value });

        let prevPrice = this.state.price;
        if (value === 'Flash') this.setState({ price: prevPrice + 1 });


    }
    render() {
        let form = <Form nameHandler={this.nameHandler}
			 submitHandler={this.submitHandler}
			 delivery={this.deliveryMethodHandler}/>

        if (this.props.loading)
            form = <Spinner />
        return (
            <React.Fragment>
            {form}
            </React.Fragment>
        )
    }

}


const mapStateToProps = state => {
    return {
        ingredients: state.bB.ingredients,
        totalPrice: state.bB.totalPrice,
        loading: state.order.loading,
        purchased: state.order.purchased,
        token: state.auth.token,
        userId: state.auth.userId
    }
}

const mapDispatchToProps = dispatch => {
    return {
        orderHandler: (data, token) => dispatch(orderHandler(data, token)),
        orderPurchased: () => dispatch(orderPurchased())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ContactData, axios));



// WEBPACK FOOTER //
// ./src/containers/Contact_form/ContactData.jsx